import { TIM_NS } from '@/components/chat/im.js'
import TIMUploadPlugin from 'tim-upload-plugin'
// import imApi from '@/api/im'
import talentApi from '@/api/talent'
import CompanyApi from '@/api/company'
const TIM = TIM_NS
import axios from '@/api/axios'
import imApi from '@/api/im'
import TabBlinker from '@/utils/tabBlink'

// 生成im所需id
async function generateUserSig(id) {
    const env = process.env.NODE_ENV === 'production'
    const client = localStorage.getItem('client')
    const envkey = env ? 'P' : 'D'
    const clientKey = client === 'talent' ? 'U' : 'S'

    const serviceApiPrev = client === 'talent' ? 'c' : 'b'
    const imUid = envkey + clientKey + id
    const params = {
        uid: imUid,
    }
    return await axios.get(`/${serviceApiPrev}/base/saas/im/userSig`, { params })
}

// 定义Vuex模块
const chat = {
    namespaced: true,
    // 状态层
    state: {
        chat: null, // IM实例
        chatShow: false, // 弹窗展示状态
        initState: false, // 初始化状态
        loginSuccessData: {}, // 登录成功数据
        rightMessageList: [], // 右侧当前聊天消息
        currentChatId: null, // 当前聊天ID
        oppositeUserID: null, // 对方的id
        currentLastMessage: null, // 当前最后一条消息
        isLoadingMore: false, // 加载更多状态
        nextReqMessageID: null, // 分页消息ID
        userInfo: {}, // 用户信息
        SDKAppID: null, // IM应用ID
        userID: '', // 用户ID
        userSig: '', // 用户签名
        isReady: false,
        leftConversationList: [], // 添加会话列表状态
        customerServiceInfo: null, // 客服信息
        noReadCustomMessageState: false, // 未读的一条客服消息显示状态
    },

    //  mutations：同步修改状态
    mutations: {
        SET_CHAT_CONFIG: (state, chatConfig) => (state.chatConfig = chatConfig),
        SET_LEFT_CONVERSATION_LIST(state, payload) {
            state.leftConversationList = payload
        },
        SET_CHAT(state, payload) {
            state.chat = payload
        },
        SET_CUSTOMER_SERVICE_INFO(state, payload) {
            state.customerServiceInfo = payload
        },
        SET_CHAT_SHOW(state, payload) {
            state.chatShow = payload
        },
        SET_INIT_STATE(state, payload) {
            state.initState = payload
        },
        SET_LOGIN_SUCCESS_DATA(state, payload) {
            state.loginSuccessData = payload
        },
        SET_RIGHT_MESSAGE_LIST(state, payload) {
            state.rightMessageList = payload
        },
        SET_CURRENT_CHAT_ID(state, payload) {
            state.currentChatId = payload
        },
        SET_CURRENT_LAST_MESSAGE(state, payload) {
            state.currentLastMessage = payload
        },
        SET_IS_LOADING_MORE(state, payload) {
            state.isLoadingMore = payload
        },
        SET_NEXT_REQ_MESSAGE_ID(state, payload) {
            state.nextReqMessageID = payload
        },
        SET_USER_INFO(state, payload) {
            state.userInfo = payload
        },
        SET_SDK_APP_ID(state, payload) {
            state.SDKAppID = payload
        },
        SET_USER_ID(state, payload) {
            state.userID = payload
        },
        SET_USER_SIG(state, payload) {
            state.userSig = payload
        },
        SET_IS_READY(state, payload) {
            state.isReady = payload
        },
        SET_OPPOSITE_USER_ID(state, payload) {
            state.oppositeUserID = payload
        },
        SET_NO_READ_MESSAGE(state, status) {
            state.noReadCustomMessageState = status
        },

    },

    // actions：处理异步操作
    actions: {
        // 切换聊天弹窗显示状态
        chatModalToggle({ state, commit, dispatch }, chatId) {
            const newState = !state.chatShow
            commit('SET_CHAT_SHOW', newState)
            
            if (chatId) {
                commit('SET_CURRENT_CHAT_ID', chatId)
                dispatch('getMessage', { loadMore: false })
            }
            return newState
        },

        // 初始化IM
        async init({ commit, dispatch, state } = {}) {
            // if (state.initState) {
            //     console.warn('IM已初始化，无需重复调用')
            //     return
            // }
            // eslint-disable-next-line
            // debugger
            if (localStorage.getItem('token')) {
                const isCompany = localStorage.getItem('client') === 'company'
                let id
                if (isCompany) {
                    id = JSON.parse(localStorage.getItem('user_info')).id
                } else {
                    id = JSON.parse(localStorage.getItem('user_info')).basic_info.uuid
                }

                const config = await generateUserSig(id)
               
                commit('SET_SDK_APP_ID', config.data.appid)
                commit('SET_USER_SIG', config.data.sig)
                commit('SET_USER_ID', config.data.uid)
                const TT_IM = localStorage.getItem('TT_IM')
                if (TT_IM) {
                    const imParams = JSON.parse(TT_IM)
                    commit('SET_CUSTOMER_SERVICE_INFO', imParams)
                    commit('SET_OPPOSITE_USER_ID', imParams.customer_server)
                    commit('SET_CURRENT_CHAT_ID', imParams.customer_server)
                } else {
                    let res
                    if (isCompany) {
                        res = await CompanyApi.getImUserSig({ companyId: id })
                    } else {
                        res = await talentApi.getImUserSigC()
                    }
                    if (res.code === 0) {
                        // const imParams = {
                        //     appid: res.data.appid,
                        //     uid: res.data.imAccount,
                        //     sig: res.data.sig,
                        //     targetImId: res.data.customServer
                        // }
                        localStorage.setItem('TT_IM', JSON.stringify(res.data))
                        commit('SET_CUSTOMER_SERVICE_INFO', res.data)
                        commit('SET_OPPOSITE_USER_ID', res.data.customer_server)
                        commit('SET_CURRENT_CHAT_ID', res.data.customer_server)
                    } else {
                        this.$message.error(res.message)
                    }
                }
            } else {
                //  游客
                const DM_IM = localStorage.getItem('DM_IM')
                if (DM_IM) {
                    const imParams = JSON.parse(DM_IM)
                    commit('SET_CUSTOMER_SERVICE_INFO', imParams) // 客服信息
                    commit('SET_SDK_APP_ID', imParams.appid)
                    commit('SET_USER_ID', imParams.imAccount)
                    commit('SET_USER_SIG', imParams.sig)
                    commit('SET_OPPOSITE_USER_ID', imParams.customServer)
                    commit('SET_CURRENT_CHAT_ID', imParams.customServer)
                } else {
                    const res = await imApi.imAccount()
                    if (res.code === 0) {
                        const imParams = {
                            appid: res.data.appid,
                            uid: res.data.imAccount,
                            sig: res.data.sig,
                            targetImId: res.data.customServer,
                        }
                        localStorage.setItem('DM_IM', JSON.stringify(res.data))
                        commit('SET_CUSTOMER_SERVICE_INFO', res.data)
                        // 2. 存储到Vuex
                        commit('SET_SDK_APP_ID', imParams.appid)
                        commit('SET_USER_ID', imParams.uid)
                        commit('SET_USER_SIG', imParams.sig)
                        commit('SET_OPPOSITE_USER_ID', imParams.targetImId)
                        commit('SET_CURRENT_CHAT_ID', res.data.customServer)
                        console.log(imParams)
                    } else {
                        this.$message.error(res.message)
                    }
                }
            }
            const chat = TIM.create({ SDKAppID: state.SDKAppID })
            chat.registerPlugin({ 'tim-upload-plugin': TIMUploadPlugin })
            chat.setLogLevel(1)
            commit('SET_CHAT', chat)
            commit('SET_INIT_STATE', true)

            // 保存dispatch引用供嵌套函数使用
            const actionDispatch = dispatch

            // 监听会话列表更新
            chat.on(TIM.EVENT.CONVERSATION_LIST_UPDATED, async () => {
                if (state.currentChatId) {
                    await actionDispatch('getMessage', { conversation: state.currentChatId })
                }
               
            })

            // 监听SDK就绪
            chat.on(TIM.EVENT.SDK_READY, async () => {
                commit('SET_IS_READY', true)
                await actionDispatch('getConversationList')
                if (state.currentChatId) {
                    await actionDispatch('getMessage', { loadMore: false })
                }
                
            })

            // 监听新消息接收
            chat.on(TIM.EVENT.MESSAGE_RECEIVED, async (event) => {
                const newMessages = event.data
                console.log(newMessages);

                if (state.currentChatId && newMessages.some((msg) => msg.conversationID === state.currentChatId)) {
                    await actionDispatch('getMessage', { conversation: state.currentChatId })
                } else {
                    await actionDispatch('getConversationList')
                }
                 const tabblinkInstance = new TabBlinker({
                    blinkText: '【收到一条新的消息】',
                    interval: 300,
                    blinkCount: 3 // 可选，默认就是3次
                });
                tabblinkInstance.start();
                commit('SET_NO_READ_MESSAGE', true)
            })
            // 登录
            dispatch('login').then(() => { })
        },
        // 登录IM
        async login({ state, commit }) {
            if (!state.initState) {
                throw new Error('IM未初始化，请先调用init')
            }
            const res = await state.chat.login({
                userID: state.userID,
                userSig: state.userSig,
            })
            try {
                commit('SET_LOGIN_SUCCESS_DATA', res.data)
                return res.data // 返回登录结果
            } catch (e) {
                console.error('登录失败', e)
                throw e // 抛出错误给调用方处理
            }
        },

        // 登出IM
        async logout({ state, commit }) {
            if (state.chat) {
                const res = await state.chat.logout()
                commit('SET_USER_SIG', '')
                commit('SET_USER_ID', '')
                commit('SET_IS_READY', null)
                commit('SET_LOGIN_SUCCESS_DATA', null)
                commit('SET_CURRENT_CHAT_ID', '')
                commit('SET_OPPOSITE_USER_ID', '')
                commit('SET_CHAT_SHOW', false)
                commit('SET_RIGHT_MESSAGE_LIST', [])
                localStorage.removeItem('DM_IM')
                localStorage.removeItem('TT_IM')
                console.log('登出成功', res)
            }
        },

        // 获取会话列表
        async getConversationList({ state, commit }) {
            // 添加SDK就绪检查
            if (!state.isReady) {
                console.error('获取会话列表失败：SDK尚未就绪，请等待SDK初始化完成')
                return
            }

            if (state.chat && state.chat.getMyProfile()) {
                const res = await state.chat.getConversationList()
                if (res.data) {
                    commit('SET_LEFT_CONVERSATION_LIST', res.data.conversationList)
                }
            }
        },

        // 发送文本消息
        async sendMessage({ state, dispatch }, { text, toId }) {
            try {
                console.log('发送文本消息', state.chat && state.chat.getMyProfile())
                if (state.chat && state.chat.getMyProfile()) {
                    console.log('发送消息', {
                        to: toId,
                        conversationType: TIM.TYPES.CONV_C2C,
                        payload: { text },
                        needReadReceipt: true,
                    })
                    const message = state.chat.createTextMessage({
                        to: toId,
                        conversationType: TIM.TYPES.CONV_C2C,
                        payload: { text },
                        needReadReceipt: true,
                    })
                    await state.chat.sendMessage(message)
                    // 发送成功后刷新消息列表
                    await dispatch('getMessage', { conversation: state.currentChatId })
                    if (localStorage.getItem('token')) {
                        dispatch('syncMessageToServer', {
                            msg_type: 'text_elem',
                            content: text,
                        })
                    } else {
                        dispatch('syncMessageToServerNoAuth', {
                            msg_type: 'text_elem',
                            content: text,
                        })
                    }
                }
            } catch (e) {
                console.error('发送消息失败', e)
            }
        },

        // 获取消息列表
        async getMessage({ state, commit }, { loadMore = false }) {
            // 等待SDK就绪
            if (!state.isReady) {
                console.log('等待SDK初始化完成...')
                await new Promise((resolve) => {
                    const checkReady = () => {
                        if (state.isReady) {
                            const data = {
                                from_uid: state.userID.slice(2),
                                to_uid: state.oppositeUserID.slice(2),
                            }
                            CompanyApi.IMServiceInitB(data)
                            resolve()
                        } else {
                            setTimeout(checkReady, 100)
                        }
                    }
                    checkReady()
                })
            }
            if (!state.chat || state.isLoadingMore) return
            const params = {
                conversationID: 'C2C' + state.currentChatId,
                count: 20,
            }
            // 加载更多逻辑
            if (loadMore) {
                if (!state.nextReqMessageID) {
                    console.log('已加载全部历史消息')
                    return
                }
                params.nextReqMessageID = state.nextReqMessageID
                commit('SET_IS_LOADING_MORE', true)
            } else {
                // 首次加载清空现有列表
                commit('SET_RIGHT_MESSAGE_LIST', [])
            }

            try {
                const res = await state.chat.getMessageList(params)
                commit('SET_NEXT_REQ_MESSAGE_ID', res.data.nextReqMessageID)

                if (loadMore) {
                    // 加载更多：向前追加
                    commit('SET_RIGHT_MESSAGE_LIST', [...res.data.messageList, ...state.rightMessageList])
                } else {
                    // 首次加载：直接替换
                    commit('SET_RIGHT_MESSAGE_LIST', res.data.messageList)
                }
            } catch (error) {
                console.error('获取消息失败', error)
            } finally {
                if (loadMore) {
                    commit('SET_IS_LOADING_MORE', false)
                }
            }
        },

        // 同步消息到服务端 用户没有登录
        async syncMessageToServerNoAuth(state, payload) {
            const { msg_type, content } = payload
            const imConfig = JSON.parse(localStorage.getItem('DM_IM') || '{}')
            const params = {
                chat_u_id: imConfig.customServer.slice(2), // 客服
                content,
                msg_type,
                guest_uid: imConfig.imAccount.slice(2),
                custom_msg_type: 'default_custom_message',
            }
            const res = await talentApi.saveMessageToTalentNoAuth(params)
            if (res.code === 0) {
                console.log(res.data)
            }
        },
        // 同步消息到服务端 用户登录
        async syncMessageToServer(state, payload) {
            const isCompany = localStorage.getItem('client') === 'company'
            const { msg_type, content } = payload
            console.log('同步消息到服务端', state)
            const params = {
                chat_u_id: state.state.oppositeUserID.slice(2), // 客服
                content,
                msg_type,
                opposite_type: 3,
                custom_msg_type: 'default_custom_message',
            }
            if (isCompany) {
                await CompanyApi.saveChatImToB(params)
            } else {
                await talentApi.saveChatImToC(params)
            }
        },
        // 图片上传
        async handleFileChange({ state }, { file, toId }) {
            if (!file.raw || !state.chat) return
            try {
                const imageMessage = state.chat.createImageMessage({
                    to: toId,
                    conversationType: TIM.TYPES.CONV_C2C,
                    payload: { file: file.raw },
                })

                const res = await state.chat.sendMessage(imageMessage)
                console.log('图片发送成功', res)
                // 获取原图URL
                const imageUrl = res.data.message.payload.imageInfoArray[0].url
                console.log('图片上传成功，原图路径:', imageUrl)

                // dispatch('syncMessageToServerNoAuth',{
                //     msg_type: 'image_elem',
                //     content: imageUrl
                // })
            } catch (error) {
                console.error('图片发送失败', error)
            }
        },
    },

    // getters：计算属性
    getters: {},
}

export default chat
